import { render, staticRenderFns } from "./UserGallery.vue?vue&type=template&id=1503dc00&scoped=true&"
import script from "./UserGallery.vue?vue&type=script&lang=js&"
export * from "./UserGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1503dc00",
  null
  
)

export default component.exports